import {
  CreditCard,
  GitBranch,
  Headset,
  Home,
  PhoneCall,
  Receipt,
  Users,
} from 'lucide-react'

/** Navegação focada em operação do cliente final */
export const voiceNavItems = [
  {
    path: '/',
    label: 'Início',
    shortLabel: 'Início',
    title: 'Início',
    description: 'Resumo da operação de voz da sua empresa.',
    icon: Home,
    end: true,
  },
  {
    path: '/ramais',
    label: 'Ramais',
    shortLabel: 'Ramais',
    title: 'Cadastrar ramais',
    description: 'Vincule atendentes aos ramais de atendimento.',
    icon: Headset,
  },
  {
    path: '/planos',
    label: 'Planos',
    shortLabel: 'Planos',
    title: 'Contratar planos',
    description: 'Assinatura mensal cobrada direto no cartão.',
    icon: CreditCard,
  },
  {
    path: '/creditos',
    label: 'Créditos',
    shortLabel: 'Créditos',
    title: 'Comprar créditos',
    description: 'Adicione saldo (pode ser compartilhado com WappDesk).',
    icon: Receipt,
  },
  {
    path: '/numeros',
    label: 'Números',
    shortLabel: 'Números',
    title: 'Comprar números avulsos',
    description: 'Contrate números de telefone avulsos para sua conta.',
    icon: PhoneCall,
  },
  {
    path: '/filas',
    label: 'Filas',
    shortLabel: 'Filas',
    title: 'Configurar filas',
    description: 'Distribua chamadas entre os atendentes.',
    icon: GitBranch,
  },
  {
    path: '/atendentes',
    label: 'Atendentes',
    shortLabel: 'Atendentes',
    title: 'Atendentes',
    description: 'Base de atendentes reaproveitada para ramais.',
    icon: Users,
  },
]

export const voiceDashboardCards = voiceNavItems.filter((item) => item.path !== '/')
